import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faCheckCircle, faCircle, faCircleCheck, faDashboard, faMagnifyingGlass, faMap, faUser, faUserAlt, faUsers } from "../../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { faPinterest } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'; // import dropdown icon
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";



const AdminSideBarNature = ({ setHeader }) => {

  function toggleClass() {
    document.getElementById("toggleli").childNodes[1].classList.toggle("collapse")
  }
  function masterClass() {
    document.getElementById("Master").childNodes[1].classList.toggle("collapse")
  }
  const [assignOpen, setAssignOpen] = useState(false);
  const [assignOpens, setAssignOpens] = useState(false);
  const [reportsOpen14, setReportsOpen14] = useState(false);
  const userType = sessionStorage.getItem("userTypeCodeModel");
  console.log('userType:', userType);
  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  const validSchemeCodesForSeedDemonstrationFarmers = ["20", "9", "8", "5", "15","46","48"];
  // const validSchemeCodesForSeedDemonstrationFarmers = [""];

  return (

    <aside id="myDIV" className="sidebar">

      <ul className="sidebar-nav" id="sidebar-nav">

        <li className="nav-item">
          <NavLink className="nav-link collapsed" to="/newadminpanel/dashboard">
            <i><FontAwesomeIcon icon={faDashboard} /></i>
            <span> Dashboard</span>
          </NavLink>
        </li>


        {!["5", "7","48"].includes(sessionStorage.getItem("userTypeCodeModel")) && (
          <li className="nav-item">
            <NavLink className="nav-link collapsed" to="/newadminpanel/userlist">
              <i><FontAwesomeIcon icon={faUsers} /></i>
              <span>User</span>
            </NavLink>
          </li>
        )}

        {sessionStorage.getItem("userTypeCodeModel") !== "7" && (
          <>
            {sessionStorage.getItem("schemeCodeModel") === "19" ? (
              <li className="nav-item">
                <NavLink className="nav-link collapsed" to="/scheme/survey">
                  <i><FontAwesomeIcon icon={faUser} /></i>
                  <span>Survey Details</span>
                </NavLink>
              </li>
            ) : ["12", "13", "14", "44"].includes(sessionStorage.getItem("schemeCodeModel")) ? (
              <li className="nav-item">
                {sessionStorage.getItem("schemeCodeModel") !== "14" && (
                  <NavLink className="nav-link collapsed" to="/newadminpanel/farmer">
                    <i><FontAwesomeIcon icon={faUser} /></i>
                    <span>Survey Details</span>
                  </NavLink>
                )}

                {sessionStorage.getItem("userRoleCodeModel") === "1" && (
                  <NavLink className="nav-link collapsed" to="/newadminpanel/geojson/view">
                    <i><FontAwesomeIcon icon={faCircleCheck} /></i>
                    <span>Geo Json Details</span>
                  </NavLink>
                )}
                {/* Rupali */}

                {(sessionStorage.getItem("userTypeCodeModel") === "2" || sessionStorage.getItem("userTypeCodeModel") === "3" || sessionStorage.getItem("userTypeCodeModel") === "4") && sessionStorage.getItem("schemeCodeModel") === "12" && (
                  <NavLink className="nav-link collapsed" to="/newadminpanel/geojson/view">
                    <i><FontAwesomeIcon icon={faCircleCheck} /></i>
                    <span>Geo Json Details</span>
                  </NavLink>
                )}

                {sessionStorage.getItem("schemeCodeModel") === "140" && (
                  <>
                    {["1", "2", "3", "4"].includes(userType) &&
                      <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span>Assign Target</span>
                      </NavLink>
                    }
                  </>
                )}
                {sessionStorage.getItem("schemeCodeModel") === "14" && (
                  <>
                    {["5","48"].includes(userType) &&
                      <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span>Target</span>
                      </NavLink>
                    }
                    <a
                      href="#!"
                      className="nav-link"
                      onClick={(e) => { e.preventDefault(); setReportsOpen14(!reportsOpen14); }}
                    >
                      <i><FontAwesomeIcon icon={faChartLine} /></i>
                      <span style={{ marginRight: '20px' }}>Reports</span>
                      <i
                        style={{
                          transition: 'transform 0.3s',
                          transform: reportsOpen14 ? 'rotate(180deg)' : 'rotate(0deg)'
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronDown} />
                      </i>
                    </a>
                    {reportsOpen14 && (
                      <ul className="submenu">
                        <li>
                          <NavLink
                            className="nav-link collapsed"
                            to="/newadminpanel/farmer"
                            state={{ header: "Surveys" }}
                            onClick={() => {
                              if (typeof setHeader === 'function') setHeader("Surveys");
                              try { sessionStorage.setItem('farmerHeader', 'Surveys'); } catch (_) { }
                            }}
                          >
                            <span>Survey Details</span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="nav-link collapsed"
                            to="/newadminpanel/assetsReportOp"
                            state={{ header: "Assets Report" }}
                          >
                            <span>Assets Report</span>
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </>
                )}
              </li>
            ) : (
              <>

                {/* <li className="nav-item">
                          <NavLink className="nav-link collapsed" to="/newadminpanel/farmer">
                            <i><FontAwesomeIcon icon={faUser} /></i>
                            <span>
                              {sessionStorage.getItem("schemeCodeModel") === "15" ? "Projects" : "Farmer"}
                            </span>
                          </NavLink>
                        </li> */}
                {!validSchemeCodesForSeedDemonstrationFarmers.includes(
                  schemeCode
                ) && (
                    <li className="nav-item">
                      <NavLink
                        className="nav-link collapsed"
                        to="/newadminpanel/farmer"
                      >
                        <i>
                          <FontAwesomeIcon icon={faUser} />
                        </i>
                        <span>
                          {sessionStorage.getItem("schemeCodeModel") === "15"
                            ? "Projects"
                            : "Survey Details"}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {sessionStorage.getItem("schemeCodeModel") === "50" && (
                  <>
                    {["1", "2"].includes(userType) &&
                      <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span>Assign Target</span>
                      </NavLink>
                    }
                    {["3"].includes(userType) &&
                      <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span>Target</span>
                      </NavLink>
                    }
                  </>
                )}
               
                {validSchemeCodesForSeedDemonstrationFarmers.includes(
                  schemeCode
                ) && schemeCode != "5" && schemeCode != "48" && sessionStorage.getItem("schemeCodeModel") !== "20" && (
                    <>
                      <li className="nav-item">
                        <NavLink
                          className="nav-link collapsed"
                          to="/newadminpanel/farmer"
                          state={{ header: "Surveys" }}
                          onClick={() => {
                            if (typeof setHeader === 'function') setHeader("Surveys");
                            try { sessionStorage.setItem('farmerHeader', 'Surveys'); } catch (_) { }
                          }}
                        >
                          <i>
                            <FontAwesomeIcon icon={faUser} />
                          </i>
                          <span>Survey Details</span>
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          className="nav-link collapsed"
                          to="/newadminpanel/seedDemonstration"
                          state={{ header: "Seed Demonstration" }}
                          onClick={() => {
                            if (typeof setHeader === 'function') setHeader("Seed Demonstration");
                            try { sessionStorage.setItem('farmerHeader', 'Seed Demonstration'); } catch (_) { }
                          }}
                        >
                          <i>
                            <FontAwesomeIcon icon={faUser} />
                          </i>
                          <span>Seed Demonstration</span>
                        </NavLink>
                      </li>
                    </>
                  )}

              {validSchemeCodesForSeedDemonstrationFarmers.includes(schemeCode) &&
  ["5", "20", "48"].includes(schemeCode) && (
    <li className="nav-item">
      {/* Parent Link */}
      <a
        href="#!"
        className="nav-link"
        onClick={(e) => {
          e.preventDefault();
          setAssignOpens(!assignOpens);
        }}
      >
        <i><FontAwesomeIcon icon={faChartLine} /></i>
        <span style={{ marginRight: '20px' }}>Reports</span>

        {/* Dropdown Icon */}
        <i
          style={{
            transition: 'transform 0.3s',
            transform: assignOpens ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          <FontAwesomeIcon icon={faChevronDown} />
        </i>
      </a>

      {/* Dropdown */}
      {assignOpens && (
        <ul className="submenu">

          {/* ✅ Only for Scheme 5 */}
         {["5", "48"].includes(schemeCode) && (
            <>
              <li>
                <NavLink
                  className="nav-link collapsed"
                  to="/newadminpanel/farmer"
                  state={{ header: "Surveys" }}
                >
                  <span>Seed Distribution</span>
                </NavLink>
              </li>
          {schemeCode === "5" && (
          <li>
            <NavLink
              className="nav-link collapsed"
              to="/newadminpanel/assetsReport"
              state={{ header: "Assets Report" }}
            >
              <span>Assets Report</span>
            </NavLink>
          </li>
        )}
      </>
    )}

          {/* ✅ Common (for BOTH 5 & 20) */}
          <li>
            <NavLink
              className="nav-link collapsed"
              to="/newadminpanel/seedDemonstration"
              state={{ header: "Seed Demonstration" }}
              onClick={() => {
                if (typeof setHeader === 'function') setHeader("Seed Demonstration");
                try {
                  sessionStorage.setItem('farmerHeader', 'Seed Demonstration');
                } catch (_) {}
              }}
            >
              <span>Seed Demonstration</span>
            </NavLink>
          </li>

        </ul>
      )}
    </li>
)}
              </>
            )}
          </>
        )}



        <li className="nav-item" style={{ display: "none" }}>
          <NavLink className="nav-link collapsed" to="/home/access">
            <i><FontAwesomeIcon icon={faDashboard} /></i>
            <span> All Schemes</span>
          </NavLink>
        </li>

        {/*{["1", "2", "3","4"].includes(userType) && */}
        {/* <li className="nav-item">*/}
        {/*     <NavLink className="nav-link" to="/newadminpanel/assignTarget">*/}
        {/*         <i><FontAwesomeIcon icon={faUsers} /></i>*/}
        {/*         <span>Assign Target</span>*/}
        {/*     </NavLink>*/}
        {/* </li>*/}
        {/* }*/}
        {["1", "2", "3", "4"].includes(userType) && (
          <li className="nav-item">
            {/* Parent Link */}
            <a
              href="#!"
              className="nav-link"
              onClick={(e) => { e.preventDefault(); setAssignOpen(!assignOpen); }}
            >

              <i><FontAwesomeIcon icon={faBullseye} /></i>
              <span style={{ marginRight: '20px' }}>Assign Target</span>


              {/* Dropdown Icon */}
              <i
                style={{
                  transition: 'transform 0.3s',
                  transform: assignOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              >
                <FontAwesomeIcon icon={faChevronDown} />
              </i>
            </a>

            {/* Dropdown Children */}
            {assignOpen && (
              <ul className="submenu">
                {/* Child: Assign Target */}
                {["1", "2", "3"].includes(userType) && (
                  <li>
                    <NavLink className="nav-link" to="/newadminpanel/assignTarget">

                      Assign Target
                    </NavLink>
                  </li>
                )}
                {(schemeCode === "5") &&
                    <li>
                      <NavLink className="nav-link collapsed" to="/newadminpanel/assetsNmeos">
                        <span>Assets Target</span>
                      </NavLink>
                    </li>
                }
                {schemeCode === "14" &&
                    <li>
                      <NavLink className="nav-link collapsed" to="/newadminpanel/assetsNmeop">
                        <span>Assets Target</span>
                      </NavLink>
                    </li>
                }

                {/* Child: Self Assigned Target */}
                {["2", "3", "4"].includes(userType) && (
                  <li>
                    <NavLink className="nav-link" to="/newadminpanel/selfAssignedTarget">
                      {userType === '2'
                        ? 'Center'
                        : userType === '3'
                          ? 'State'
                          : userType === '4'
                            ? 'District'
                            : ''} Assigned Target
                    </NavLink>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}

        {sessionStorage.getItem("schemeCodeModel") === "1" && (
          <>
            {["5"].includes(userType) &&
              <li className="nav-item">
                <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                  <i><FontAwesomeIcon icon={faUsers} /></i>
                  <span>Target</span>
                </NavLink>
              </li>
            }
          </>
        )}
        {sessionStorage.getItem("userTypeCodeModel") === "7" && (
          <>

            <li className="nav-item">
              <NavLink className="nav-link collapsed" to="/newadminpanel/allocatedcase">
                <i><FontAwesomeIcon icon={faUser} /></i>
                <span>Allocated Case</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link collapsed" to="/newadminpanel/allocatedcase">
                <i><FontAwesomeIcon icon={faUser} /></i>
                <span>Total Allocated</span>
              </NavLink>
            </li>
          </>
        )}






      </ul>

    </aside>
  )

}

export default AdminSideBarNature;